/*
 * @fileOverView Date component definition
 */

import Vue from 'vue';
import 'jquery-validation';
import moment from 'moment';

/**
 * [Date Vue]
 * @type {class}
 */
Vue.component('date-vue', {
  props: {
    "defaultDate": {
      default: moment().format('MMM-DD-YYYY'),
      type: String
    },
    "defaultEmpty": false
  },

  data: function () {
    return {
      activeStep: 1,
      month: -1,
      day: -1,
      year: -1,
      defaultYear: '',
      defaultMonth: '',
      defaultDay: ''
    }
  },

  computed: {
    dateString: function () {
      return this.momentDate.format('YYYY-MM-DD');
    },

    momentDate: function () {
      return moment(`${this.month}-${this.day}-${this.year}`, 'MMM-DD-YYYY');
    }
  },

  watch: {
    dateString: function(val) {
      this.$emit('update:date', val);
    }
  },

  mounted() {
    this.$computedDate = $(this.$refs.computedDate);
    this.parseDefaultDate();
    this.addGenericValidationRules();
  },

  methods: {
    parseDefaultDate() {
      if (this.defaultEmpty) {
        return;
      }

      const defaultDate = moment(this.defaultDate, 'MMM-DD-YYYY');
      this.defaultDay = defaultDate.format('D');
      this.day = this.defaultDay;
      this.defaultMonth = defaultDate.format('MMM');
      this.month = this.defaultMonth;
      this.defaultYear = defaultDate.format('YYYY');
      this.year = this.defaultYear;
      this.$nextTick(() => {this.$emit('update:date', this.dateString)});
    },

    addGenericValidationRules() {
      // Validate a past date, such as a date of birth.
      $.validator.addMethod("date_past", (value) => {
        const date = moment(value, 'YYYY-MM-DD');
        const now = moment().startOf('day');
        return date.isValid() && date.isBefore(now);
      }, 'Date must be in the past.');
    },

    onYearChanged(idx, val) {
      this.handleChange('year', val, true);
    },

    onMonthChanged(idx, val) {
      this.handleChange('month', val, true);
    },

    onDayChanged(idx, val) {
      this.handleChange('day', val, true);
    },

    handleChange(name, value, validate) {
      this[name] = value;

      if (!validate) return;

      this.$nextTick(() => {
        if (typeof this.$computedDate.valid === 'function') {
          this.$computedDate.valid();
        }
      });
    }
  }
})
